/**
 *
 * @type {*|jQuery|HTMLElement}
 */
var toggleNav = $('.toggle-nav');

/**
 *
 * @type {*|jQuery|HTMLElement}
 */
var overlay = $('.overlay');

/**
 *
 * @type {*|jQuery|HTMLElement}
 * @private
 */
var _search = $('.search');

/**
 *
 * @type {*|jQuery|HTMLElement}
 */
var dropdownToggle = $('.dropdown-toggle');

// LazyLoad activation options.
var lazyLoadOptions = {
  callback_set: function(element) {
    $(element).removeAttr('data-was-processed');
    $(element).removeClass("loading");
    $(element).removeClass("error");
  },
  callback_load: function(element) {
    $(element).removeAttr('data-src');
    $(element).removeAttr('data-was-processed');
    $(element).removeClass("loaded");
    $(element).removeClass("error");
  },
  callback_enter: function(element) {
    if ($(element).data('src') == '') {
      $(element).attr("src", "");
    }
  }
};

// LazyLoad activation variable.
var activateLazyLoading= new LazyLoad(lazyLoadOptions);

// LazyLoad update
$(document).click(function() {
  activateLazyLoading.update();
});

$( document ).ajaxComplete(function() {
  activateLazyLoading.update();
});

$(".owl-carousel").on('changed.owl.carousel', function() {
  activateLazyLoading.update();
});


/**
 * Display carousels on window load
 */
var carouselLoader = "<div align='center' class='carouselLoader'><img src='"+ACC.config.commonResourcePath+"/img/img-defer-spinner.svg' " +
		"width='48'/></div>";
$(carouselLoader).insertAfter(".owl-carousel");
$(window).on('load',function(){
    $(".carouselLoader").remove();
    $(".owl-carousel").css("display","block");
    if(isMobile) {
        setTimeout(explode, 100);
    }
});
var explode = function(){
    if($('.owl-dots').find("div").length<=6){
        $('.js-carousel .owl-stage > li').addClass("dynamic-carr-6");
        $('.page-AccessoriesHomePage .owl-carousel.js-carousel').find(".item-discover").each(function () {
          $(this).closest(".owl-item.dynamic-carr-6").addClass("dynamic-carr-6-discover");
        });
    }
};
$(function () {

    /**
     * Breadcrumb
     */
    // Breadcrumb
    $('.breadcrumb li:last-child a').on('click', function () {
        return false;
    });

    /* BRA-8399 */
    $(document).on('click', '.page-homeEnjoyTechnology .banner-full .item a', function(e){
        e.preventDefault();
    });



    /**
     *
     */
    bindCreateUpdateAddress();

    /**
     *
     * @type {boolean}
     */
    var flag = false;
    /**
     *
     */
    toggleNav.on('touchstart click', function (e) {
        if (!flag) {
            flag = true;
            setTimeout(function () {
                flag = false;
            }, 100);
            openNav();
            e.preventDefault();
        }
        return false
    });

    /**
     *
     */
    overlay.on('click', function () {
        openNav();
    });

    if (isMobile == true) {
        /**
         *
         * @type {*|jQuery|HTMLElement}
         */
        // menu mon compte
        var toggleAcc = $('.sidebar-filters .filters > .item:first-child:not(#rp-search, #faq-search)');
        toggleAcc.addClass('toggle');
        toggleAcc.siblings().hide();
        if (toggleAcc.siblings().is(':visible')) {
            console.log('added class');
            $('.sidebar-filters .filters').addClass('open');

        }
        $(document).on('touchstart', '.toggle', function () {
            toggleAcc.siblings().stop(true, true).slideToggle(300);
            $(this).parent().toggleClass('open');
        });

        /**
         *
         * @type {*|jQuery|HTMLElement}
         */
        var toggleAcc2 = $('#accordionFiltersFaq > .accordion-group > .accordion-heading');
        toggleAcc2.addClass('toggle2');
        toggleAcc2.siblings().hide();


        $(document).on('touchstart', '.toggle2', function (e) {

            $(this).on('click', function(event) {
                event.preventDefault();
            });

            $('#accordionFiltersFaq .accordion-body').slide(300);
            $(this).parent().toggleClass('open');
        });


        /**
         *
         * @type {*|jQuery|HTMLElement}
         */
        var toggleAcc3 = $('.enjoy-rowenta-wrap #filters span.h2');
        toggleAcc3.addClass('toggle3');
        $('.enjoy-rowenta-wrap #filters ul').hide();

        $(document).on('touchstart', '.toggle3', function (e) {
            e.preventDefault();
            $('.enjoy-rowenta-wrap #filters ul').stop(true, true).slideToggle(300);
            $(this).parent().toggleClass('open');
        });

        /**
         *
         * @type {*|jQuery|HTMLElement}
         */
        var toggleAcc4 = $('.filters-faq #accordionFiltersFaq .accordion-heading a');
        toggleAcc4.addClass('toggle4');
        $('.filters-faq #accordionFiltersFaq .accordion-body').removeClass('in collapse').hide();

        $(document).on('click', '.toggle4', function (e) {
            $(this).parent().parent().find('.accordion-body').stop(true, true).slideToggle(300);
            $(this).parent().toggleClass('open');

        });
        $('.list-product .row-fluid.bloc-seo + .zone-compare').appendTo('.list-product .span3');
    }

    /* enjoy rowenta - ajout d'une petite barre sur mobile */
    /**
     *
     */
    $(".enjoy-rowenta .caption p.title").each(function () {
        $(this).append('<span></span>');
    });

    /**
     *
     */
    //gestion des menu du header
    $('.dropmenu .dropmenu-toggle, .country > a').on('click', function (e) {
        e.preventDefault();
        $('.search').removeClass('active');
        if ($(this).parent().hasClass('open')) {
            $(this).parent().toggleClass('open')
        } else {
            $('.dropmenu.open').removeClass('open');
            $(this).parent().toggleClass('open');
        }
    });

    /**
     * JS suggestions popup
     */

    $("#search").on("change paste keyup", function() {
        if($(this).val().length>0){
            $('#NoResult').hide();
        }else{
            $('#NoResult').show();
        }
    });

    /**
     *
     * @type {boolean}
     */
    var flag2 = false;
    $('.niv1 > ul.navigation > li:not(.direct-link) > a').on('touchstart click', function (e) {
        if (!flag2) {
            flag2 = true;
            setTimeout(function () {
                flag2 = false;
            }, 100);
            e.preventDefault();
            if (!$(this).parent().hasClass('direct-link')) {
                if (!$(this).parents('.niv2').length) {
                    toggleniv2($(this));
                }
            }
        }
        return false
    });

    /**
     *
     */
    $('.mobile-back').on('click', function (e) {
        e.preventDefault();
        $('.niv2').removeClass('open');
        $('.niv1 .actif').removeClass('actif');
        $('.mobile-back').hide();
        $('#darkEffectMenuOpen').remove();
    });

    /**
     *
     */
    // gestion du clique à l'exterieur des menus deroulants du header quand ils sont ouvert
    $('body').on('click', function (e) {
        if (!$('.dropmenu').is(e.target) && $('.dropmenu').has(e.target).length === 0 && $('.open').has(e.target).length === 0) {
            $('.dropmenu').removeClass('open');
        }
    });

    /**
     *
     */
    if (isMobile == true) {
        $('#trigger-search').on('click touchstart', function (e) {
            e.preventDefault();
            if (!$('.dropmenu').is(e.target) && $('.dropmenu').has(e.target).length === 0 && $('.open').has(e.target).length === 0) {
                $('.dropmenu').removeClass('open');
            }
            if (!_search.hasClass('active')) {
                //$('#trigger-search').attr('type', 'submit');
                $('body').addClass('search-open');
                _search.addClass('active');
                $('.wrap-search input[type=TEXT]').trigger('focus');
                e.preventDefault();
            }
            $(this).prev().slideDown();
        });
        $('.close-search').on('click touchstart', function (e) {
            e.preventDefault();
            $('body').removeClass('search-open');
            _search.removeClass('active');
            $('#search').trigger('blur');
            $(this).parent().slideUp();
        });
    }else {
        $('#trigger-search').on('click touchstart', function (e) {
            e.preventDefault();
            if (!$('.dropmenu').is(e.target) && $('.dropmenu').has(e.target).length === 0 && $('.open').has(e.target).length === 0) {
                $('.dropmenu').removeClass('open');
            }
            if (!_search.hasClass('active')) {
                //$('#trigger-search').attr('type', 'submit');
                $('body').addClass('search-open');
                _search.addClass('active');
                $('.wrap-search input[type=TEXT]').trigger('focus');
                e.preventDefault();
            }
        });

        $('.close-search').on('click touchstart', function (e) {
            $('body').removeClass('search-open');
            _search.removeClass('active');
            $('#search').trigger('blur');
            e.preventDefault();
        });
    }

    /**
     *
     */
    $("header .search form[name='search_form']").on('submit',function(event){
        var minLength = parseInt(ACC.searchTextMinLength);
        if($("header .search #search").val().length < minLength) {
            event.preventDefault();
        }
    });

    /**
     *
     */
    $('.dropdown-toggle').dropdown();

    /**
     *
     */
    /* Satisfaction FAQ */
    $('input[type=radio][name=notation]').on('change',function () {
        /**
         *
         * @type {*|jQuery}
         */
        var $notationForm = $(this).parents('.notation');
        $notationForm.find('input[type=submit]').prop("disabled", false);
        // console.log($('input[name=notation]:checked', $notationForm).val());
        if ($('input[name=notation]:checked', $notationForm).val() == "false") {
            $notationForm.find('.amelioration').removeClass('hidden');
            $notationForm.find('#or').removeClass('hidden');
            $notationForm.find('#contactUs').removeClass('hidden');
        } else {
            $notationForm.find('.amelioration').addClass('hidden');
            $notationForm.find('#or').addClass('hidden');
            $notationForm.find('#contactUs').addClass('hidden');
        }
    });

    /**
     *
     */
    $(".notationForm").each(function () {
        $(this).on('submit', function (e) {
            e.preventDefault();
            /**
             *
             * @type {*|jQuery|HTMLElement}
             */
            var $this = $(this);

            /**
             *
             */
            var faqUtile = $this.find('.faqUtile:checked').val();
            if (faqUtile === '') {
                //console.log('Les champs doivent êtres remplis');
            } else {
                $this.addClass('hidden');
                $this.parents('.notation').find('.thanks').removeClass('hidden');
                $.ajax({
                    url: $this.attr('action'),
                    type: $this.attr('method'),
                    data: $this.serialize(),
                }).done(function (html) {
                });
            }
        });
    });

    /**
     *
     */
    $(window).on('load',function () {

        if ($('.idee-recue .idee-recue-slide').length > 1) {

            var $ideeRecueSlider = $('.idee-recue');

            var ideeRecueSliderOptions = {
                stageElement : "ul",
                itemElement : "li",
                loop : true,
                nav : false,
                dots : true,
                mouseDrag : false,
                touchDrag : true,
                items : 1,
                slideBy : 1,
                smartSpeed : 500,
                adaptiveHeight : true,
                dotClass: "custom-dot"
            }

            $ideeRecueSlider.on("initialized.owl.carousel", function(){
                $(".idee-recue").find(".owl-stage-outer").addClass("idee-recue-wrapper");
            });

            $ideeRecueSlider.owlCarousel(ideeRecueSliderOptions);
        }

        /**
         *
         */
        $('#ifuLanguage').on('change',function () {
                $(this).closest('form').trigger('submit');
            }
        );

    });

    /**
     * ModalMedia Carousel
     */
    $('#ModalMedia').on('shown', function () {
        showLoader();
        setTimeout(function () {
            if (typeof startSlide === 'undefined') {

                var startS = $('#CarouselDetailProductBig .carousel-inner .item.active').index();

                var startThumbS = 1;
            } else {

                var startS = startSlide;

                var startThumbS = startSlide + 1;
            }

            //Big slider
            var $bigSlider = $("#CarouselDetailProductModal .carousel-inner");

            var bigSliderOptions = {
                stageElement: "ul",
                itemElement: "li",
                loop: false,
                nav: false,
                dots: false,
                animateIn: "fadeIn",
                animateOut: "fadeOut",
                mouseDrag: false,
                touchDrag: true,
                autoHeight: true,
                startPosition: startS,
                items: 1,
                slideBy: 1
            }

            $bigSlider.owlCarousel(bigSliderOptions);

            //Small slider
            var $smallSlider = $("#CarouselDetailProductMiniModal .thumbnails");

            var smallSliderOptions = {
                stageElement: "ul",
                itemElement: "li",
                loop: true,
                nav: false,
                dots: false,
                mouseDrag: false,
                touchDrag: true,
                autoWidth: true,
                responsive: {
                    0: {
                        items: 2,
                        slideBy: 2,
                        loop: false //BRA-11956
                    },
                    720: {
                        items: 4,
                        slideBy: 4
                    },
                    1023: {
                        items: 4,
                        slideBy: 4,
                        nav: true
                    }
                }
            }

            $smallSlider.on("initialize.owl.carousel", function(event) {
                var currentBreakpoint = $(window).width() > 1023 ? 1023
                    : $(window).width() > 720 ? 720
                        : 0;

                var itemsPerPage = smallSliderOptions.responsive[currentBreakpoint].items;
                var numberOfItems = $smallSlider.find('.thumbnail').length;
                var itemsNeeded = itemsPerPage - (numberOfItems % itemsPerPage);

                while(currentBreakpoint == 1023 && numberOfItems % itemsPerPage > 0 && itemsNeeded > 0){
                    var placeholder = $smallSlider.find(".thumbnail:last-child").clone().css("visibility","hidden");
                    $smallSlider.append(placeholder);
                    itemsNeeded--;
                }
            });


            $smallSlider.on("initialized.owl.carousel", function (event) {
                $("#CarouselDetailProductMiniModal li:nth-child(" + startThumbS + ") a").addClass('active');
            });

            $smallSlider.owlCarousel(smallSliderOptions);

            //Link big slider with small slider
            linkRealSliders($bigSlider, $smallSlider);

            function linkRealSliders(bigS, thumbS) {
                $("#CarouselDetailProductMiniModal .thumbnails").on("click", "a", function (e) {
                    e.preventDefault();

                    var newIndex = $(this).attr("data-slide-to");
                    bigS.trigger("to.owl.carousel", [newIndex]);
                    $("#CarouselDetailProductMiniModal .active").removeClass('active');
                    $(this).addClass('active');
                });
            }

            $("#CarouselDetailProductMiniModal li:nth-child(" + startThumbS + ") a").addClass('active');
            $('#ModalMedia .modal-body').css({
                'max-height': '100%'
            });

            hideLoader();
        }, 300);
    });

    /**
     *
     */
    ///Add close button to cart
    $("#rollover_cart_popup").prepend("<span class='close-button'>×</span>");

    /**
     *
     */
    $(document).on("click", ".close-button", function () {
        $('#rollover_cart_popup').parents().removeClass('open');
    });

    /**
     *
     */
    ////Orientation Change for Cart Popup
    window.addEventListener('orientationchange',function() {
        $.ajax({
            url: rolloverPopupUrl,
            cache: false,
            type: 'GET',
        }).done( function (result) {
                $('#rollover_cart_popup').html(result);
                if($('#rollover_cart_popup .slimScrollActive').length) {
                  var popupHeight;
                  var popupHeightBigSize = 270;
                  var minimumSize = 20;
                  var highWidthScreenMobileSize = 115;
                  var popupHeightSmallSize = window.innerHeight - $('.total-cart').outerHeight() - $("#rollover_cart_popup .arrow_box .row-fluid").outerHeight() - $('.wrap-header').outerHeight() - 60;
                  popupHeight = (window.matchMedia("(orientation: portrait)").matches ? popupHeightBigSize : (popupHeightSmallSize > popupHeightBigSize ? popupHeightBigSize : (popupHeightSmallSize < minimumSize ? highWidthScreenMobileSize : popupHeightSmallSize)));
                  $('#rollover_cart_popup .scroll .nice-scrollable').css('height', popupHeight + "px");
                  $('#rollover_cart_popup .scroll .nice-scrollable').css('max-height', popupHeight + 'px');
                  var ps = new PerfectScrollbar('#rollover_cart_popup .scroll .nice-scrollable', {
                    suppressScrollX: true,
                    wheelPropagation: false
                  });
                  $("#rollover_cart_popup .slimScrollActive, #rollover_cart_popup .total-cart").on("touchstart ps-y-reach-end", function (event) {
                    if (event.cancelable) {
                      event.preventDefault();
                      event.stopPropagation();
                    }
                  });
                }
                //$('#rollover_cart_popup').fadeIn();
            }
        ).fail(function(){
            console.log('orientationchange - rollover_cart_popup - failed');
        });
    });

    $('.product-faq .accordion-group iframe[src*="youtube"]').each(function(){
        if ($(this).attr('src').indexOf("enablejsapi") === -1) {
            var prefix = ($(this).attr('src').indexOf("?") === -1) ? "?" : "&amp;";
            $(this).attr('src', $(this).attr('src') + prefix + "enablejsapi=true");
        }
    });

    /**
     *
     */
    $(document).on('show','.accordion-group', function (e) {
        e.stopPropagation();
        $(this).addClass('active-group');
        $(e.target).prev('.accordion-heading').find('.accordion-toggle').addClass('active');
    });

    /**
     *
     */
    $(document).on('hide','.accordion-group', function (e) {
        e.stopPropagation();
        $(this).removeClass('active-group');
        $(this).find('.accordion-heading .accordion-toggle').first().removeClass('active');
        $(this).find("iframe").each(function() {
            jQuery(this)[0].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
        });
    });

    /**
     *
     */
    /* SMOOTH SCROLL on anchor click */
    $('.logo a[href*=\\#]:not([href=\\#]), a.anchor[href*=\\#]:not([href=\\#])').on('click',function () {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            /**
             *
             * @type {*|jQuery|HTMLElement}
             */
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                $('html,body').animate({
                    scrollTop: target.offset().top - 63
                }, 900);
                return false;
            }
        }
    });



    /**
     *
     */
    //init scrollable compare array in product detail page
    scrollableTable();

    /**
     *
     */
    if ($('.list-product').length) {
        refresh_compare();
        //add custom action on go compare
        initGoCompare(maxCheckError);
    }

    /**
     *
     */
    $('.disabled').on('click', function (e) {
        e.preventDefault();
    });

    /**
     *
     */
    if ($('.iCheck').length) {
        $('input[type=CHECKBOX]', $('.filters')).iCheck();
        $('input[type=CHECKBOX]', $('.filters')).on('ifChanged', function () {
            $(this).closest('form').trigger('submit')
        });
    }

    /**
     *
     */
    HighlightAutocomplete();

    /* Code temporaire seulement pour la démo de l'autocomplete */
    /* on vous prie de bien vouloir nettoyer le code
     * Merci d'avance.
     */

    /**
     *
     */
    /* iPad Hack to avoid two click instead of one*/
    $('.ui-autocomplete').on('touchstart', 'li.ui-menu-item', function () {
        /**
         *
         * @type {*|jQuery}
         */
        var $container = $(this).closest('.ui-autocomplete'),
            $item = $(this);
        //if we haven't closed the result box like we should have, simulate a click on the element they tapped on.
        function fixitifitneedsit() {
            if ($container.is(':visible') && $item.hasClass('ui-state-focus')) {
                $item.trigger('click');
                return true; // it needed it
            }
            return false; // it didn't
        }

        setTimeout(function () {
            if (!fixitifitneedsit()) {
                setTimeout(fixitifitneedsit, 600);
            }
        }, 600);
    });

    /* fin demo autocomplete*/

    /**
     *
     */
    //close modal IE Managment
    $('.modal').on('hidden', function () {
        /**
         *
         * @type {*|jQuery}
         */
        var iframe = $(this).children('div.modal-body').find('iframe');
        iframe.attr('src', '');
        $(this).removeData();
    });

    /**
     *
     */
    //close modal IE Managment
    $('#ModalCommerce').on('shown', function () {
        $(this).find('.modal-body').css({
            'max-height': '100%'
        });
    });

    /**
     *
     */
    // List product - SEE MORE handler
    $(document).on('click', '.list-recipe .show-more a', function (event) {
        $('.show-more').hide();
        /**
         *
         * @type {*|jQuery}
         */
        var url = $(this).attr("href");
        event.preventDefault();
        showLoader();
        $.ajax({
          url: url,
          type: 'GET',
          dataType: 'html',
          data: ''
        }).always(function (data) {
          $('.recipes-list').append(data);
          hideLoader();
        });
    });

    /**
     *
     */
    if ($('.list-news').length) {
        // List product - SEE MORE handler
        //var nblishown = 4,
        if (typeof nblishown !== 'undefined') {
            /**
             *
             * @type {number}
             */
            var nblishown = nblishown;
        } else {
            /**
             *
             * @type {number}
             */
            var nblishown = 4;
        }
        /**
         *
         * @type {number}
         */
        var nblitoshow = 5;

        $('.list-news ul li:nth-child(' + nblishown + ') ~ li').addClass('hidden');
        $(document).on('click', '.list-news .show-more a', function (event) {
            event.preventDefault();
            showLoader();
            /**
             *
             * @type {number|jQuery}
             */
            var nbLi = $('.list-news ul li').length,
                indexHidden = $('.list-news ul li').index($('.list-news ul li.hidden'));

            for (var i = indexHidden + 1; i < indexHidden + nblitoshow; i++) {
                $('.list-news ul li:nth-child(' + i + ')').removeClass('hidden');
                if (nbLi <= i) {
                    $('.list-news .show-more').hide();
                }
            }
            hideLoader();
        });
    }

    /**
     *
     */
    $('.recipe-product .show-more a').on('click', function (e) {
        e.preventDefault();
        showLoader();
        $('.recipe-product-list .more').show();
        $('.recipe-product .show-more').hide();
        hideLoader();
    });

    /**
     *
     */
    $('a.trigger-content').on('click', function (e) {
        e.preventDefault();
        /**
         *
         * @type {*|jQuery}
         */
        var link = $(this).attr('href');
        if (!$(this).hasClass('open')) {
            $(link).stop(true, true).show('300');
            $(this).addClass('open')
        } else {
            $(link).stop(true, true).hide('300');
            $(this).removeClass('open')
        }
    });


    /**
     *
     */


    /**
     *
     */
    function openNav() {
        /**
         *
         * @type {*|jQuery|HTMLElement}
         */
        var mainNav = $('.main-nav'),
            toggleNav = $('.toggle-nav'),
            overlay = $('.overlay');
        $('.mobile-back').hide();
        if (mainNav.hasClass('show-nav')) {
            $('html, body').css({
                overflow: 'auto'
            });
            mainNav.removeClass('show-nav');
            toggleNav.removeClass('active');
            $('.niv2').removeClass('open');
            $('.niv1 .actif').removeClass('actif');
            overlay.removeClass('open');
            $('.wrap-main-content').removeClass('open-nav');
            if (isMobile != true && isTablet != true && $("#video-wrapper").length && $("#video-wrapper").YTPGetVideoID().length >0) {
                $("#video-wrapper").YTPPlay();
            }
            if(isMobile){
                $('#darkEffectMenuOpen').remove();
            }
        } else {
            $('html, body').css({
                overflow: 'hidden'
            });
            if (isMobile != true && isTablet != true && $("#video-wrapper").length && $("#video-wrapper").YTPGetVideoID().length >0) {
                $("#video-wrapper").YTPPause();
            }
            toggleNav.addClass('active');
            mainNav.addClass('show-nav');
            mainNav.css("display","block");
            $('.niv2').css("display","block");
            overlay.addClass('open');
            $('.wrap-main-content').addClass('open-nav');
        }
        $('#rollover_cart_popup').parents().removeClass('open');
    }

    /**
     *
     */
    if ($('.addrBookContainer').length) {
        /**
         *
         * @type {number}
         */
        var HigherAddress = 0;
        $('.addrBookContainer .span4').each(function (index) {
            if ($(this).outerHeight() > HigherAddress) {
                HigherAddress = $(this).outerHeight();
            }
        });
        $('.addrBookContainer .span4').css('height', HigherAddress);
    }

    /**
     *
     */
    initScrollingStoreList();

    /**
     *
     */
    /*store locator detail*/
    $(document).on('click','.list-store li', function () {
        infowindow.close();
        $('.shopdetails').slideUp('fast');
        gotoPoint(jQuery(this).index(),jQuery(this).attr("id"));
    });

    /**
     *
     */
    $('.back-to-top a').on('click',function (e) {
        e.preventDefault();
        $('html,body').animate({
            scrollTop: 0
        }, 1000);
    });

    /**
     *
     */
    // Au change du select de la liste des accessoires
    $("#faq-sort").on('change',function () {
        /**
         *
         * @type {*|jQuery}
         */
        var selectedValue = $(this).val();
        updateURLParameter("sort", selectedValue);
    });

    /**
     *
     * @param param
     * @param paramVal
     */
    function updateURLParameter(param, paramVal) {
        /**
         *
         */
        var url = window.location.href;

        /**
         *
         * @type {string}
         */
        var newAdditionalURL = "";

        /**
         *
         */
        var tempArray = url.split("?");

        /**
         *
         */
        var baseURL = tempArray[0];

        /**
         *
         */
        var additionalURL = tempArray[1];

        /**
         *
         * @type {string}
         */
        var temp = "";
        if (additionalURL) {
            tempArray = additionalURL.split("&");
            for (i = 0; i < tempArray.length; i++) {
                if (tempArray[i].split('=')[0] != param) {
                    newAdditionalURL += temp + tempArray[i];
                    temp = "&";
                }
            }
        }
        /**
         *
         * @type {string}
         */
        var rows_txt = temp + "" + param + "=" + paramVal;
        window.location = baseURL + "?" + newAdditionalURL + rows_txt;
    }

    /**
     *
     */
    $(".emptyCart").on('click',function (e) {
        e.preventDefault();
        $('.ConfModal').modal();
    });

    /**
     *
     */
    //prevent copy /paste
    $('.noctrlcv').on("cut copy paste", function (e) {
        e.preventDefault();
    });

    /**
     *
     */
    $('.noctrlcv').on('keydown',function (event) {
        if (event.ctrlKey == true && (event.which == '118' || event.which == '86')) {
            event.preventDefault();
        }
    });

    /**
     *
     */
    jQuery("#submitFormLoginAjax").on('click',function (event) {
        /**
         *
         */
        var baseURL = jQuery("#FormLogin").attr('action');

        /**
         *
         */
        var basesecureURL = jQuery("#FormLogin").attr('secure-action');
        jQuery("#messageErrorsLogin").html('');
        event.preventDefault();
        jQuery.ajax({
            type: "post",
            data: jQuery("#FormLogin").serialize(),
            url: baseURL + "/login/request/validate"

        }).done(function (data) {
            if (data.success == true) {
                jQuery("#FormLogin").attr('action',
                    basesecureURL + "/j_spring_security_check");
                jQuery("#FormLogin").trigger('submit');
            } else {
                jQuery("#messageErrorsLogin").html(data.message);
            }
        }).fail( function () {
            jQuery("#messageErrorsLogin").html(
                errorLogin);
        });
    });

    /**
     *
     */
    jQuery("#submitForgottenPassword").on('click',function (event) {
        event.preventDefault();
        jQuery("#messageErrors").html('');
        jQuery.ajax({
            type: "POST",
            data: jQuery("#ForgottenPassword").serialize(),
            url: jQuery("#ForgottenPassword").attr('action') + "/validate"
        }).done(function (data) {
            //console.log(data);
            if (data == "OK") {
                jQuery("#ForgottenPassword").trigger('submit');
            } else {
                jQuery("#messageErrors").html(data);
            }
        }).fail( function () {
            jQuery("#messageErrors").html(errorLogin);
        });
    });

    /**
     *
     */
    jQuery("#btn-mood").on('click',function (event) {
        /**
         *
         * @type {*|jQuery}
         */
        var op1 = $('#select-humeur').val(),
            op2 = $('#select-produit').val(),
            op3 = $('#select-pour').val();
        if (op1 == "" || op2 == "" || op3 == "") {
            /**
             *
             * @type {string}
             */
            var selectModal = '#ModalMoodSearch';
            $(selectModal).show();
            $(selectModal).modal();
        }

    });

    /* Retour a la lighe apres le point*/
    /**
     *
     * @type {*|jQuery}
     */
    var test = $('.quantity .msg span').text();

    /**
     *
     */
    var result = test.replace(/\./g, '.<br/>');

    /**
     *
     */
    $('.quantity .msg span').html(result);

    /**
     *
     */
    $('.CountrySeletorBC').on('click',function () {
        $(this).parent().find('.country-selector-bc').toggle();
    });

    /**
     *
     */
    $('.country-selector-bc').on('mouseleave',function () {
        $('.country-selector-bc').hide();
    });

    /**
     *
     * @param clickNiv1
     */
    function toggleniv2(clickNiv1) {
        $('.niv2').removeClass('open');
        clickNiv1.parent().find('.niv2').addClass('open');
        $('.niv1 .actif').removeClass('actif');
        clickNiv1.addClass('actif');
        $('.mobile-back').show();
        if(isMobile){
            var divDarkEffect = document.createElement("div");
            $(divDarkEffect).attr('id','darkEffectMenuOpen');
            $('.niv2.open').closest('ul').prepend(divDarkEffect);
            $(divDarkEffect).css({
                'position': 'absolute',
                'top': '0',
                'left': '0',
                'height': '100%',
                'width': '100%',
                'opacity': '0.6',
                'background-color': '#000',
                'z-index': '18'
            });
        }

    }

    /**
     *
     */
    if ($('.banner-full').length) {
        /**
         *
         * @type {*|jQuery|HTMLElement}
         */
        var bannerFull = $('.banner-full');

        /**
         *
         */
        var image = bannerFull.find('.border img').attr("data-src");
        if (typeof image !== typeof undefined && image !== false) {
            bannerFull.css("background-image", "url(" + image + ")");
            bannerFull.find('.border').remove();
        } else {
            image = bannerFull.find('.border img').attr("src");
            bannerFull.css("background-image", "url(" + image + ")");
            bannerFull.find('.border').remove();
        }
    }



    /**
     *
     */
    /* on load AJAX CALL */
    if ($('#product-finder').length) {
        var url = $('#product-finder').attr("data-attr");
        var success = false;
        $.ajax({
            url: url,
            type: 'GET',
            dataType: 'html',
            data: ''
        }).done( function (resposta) {
            success = true;
        }).fail( function (xhr, ajaxOptions, thrownError) {
            success = false;
        }).always( function (data) {
            if (success == true) {
                $('#product-finder').html(data);
            }
            hideLoader();
        });

        /* Product finder AJAX CALL*/
        $(document).on('click', '.step-form .step-buttons a', function (event) {
            event.preventDefault();
            if ($(".step-form input:radio[name=btnradio]").is(":checked")) {
                var url = $(this).attr("href");
                showLoader();
                var answer = $(".step-form input:radio[name=btnradio]:checked").attr("id");
                url = url + "/" + answer;
                success = false;
                $.ajax({
                    url: url,
                    type: 'GET',
                    dataType: 'html',
                    data: ''
                }).done(function (resposta) {
                    success = true;
                }).fail( function (xhr, ajaxOptions, thrownError) {
                    $('.step-guide .error').show();
                    success = false;
                }).always( function (data) {
                    if (success == true) {
                        $('#product-finder').html(data);
                    }
                    hideLoader();
                });
            }
        });

        $(document).on('click', '.step-indicators li a', function (event) {
            event.preventDefault();
            if (!$(this).hasClass('next')) {
                var url = $(this).attr("href");
                showLoader();
                success = false;
                $.ajax({
                    url: url,
                    type: 'GET',
                    dataType: 'html',
                    data: ''
                }).done(function (resposta) {
                    success = true;
                }).fail( function (xhr, ajaxOptions, thrownError) {
                    $('.step-guide .error').show();
                    success = false;
                }).always( function (data) {
                    if (success == true) {
                        $('#product-finder').html(data);
                    }
                    hideLoader();
                });
            }
        });
    }

    /**
     *
     */
    //Script mobile pour deplacer la banner avec le titre des pages en 2 colonnes
    if (isMobile == true) {
        $('.store-on-line-intro .border:first').addClass('mobile-banner').insertBefore('.page-StoreFinderOnLinePage .main-content .row-fluid.bloc-light:first .span3');
        ;
        $('.consumer-services-wr.warrantyp .faq-banner .border, .rowenta-portal-banner .border').addClass('mobile-banner');
        $('.list-cat .row-fluid.bloc-light .span9 > div.picture').addClass('mobile-banner').insertBefore('.list-cat .row-fluid.bloc-light');
        $('.page-faqhomepage .row-fluid.bloc-light .span9 > .faq-banner div.picture').addClass('mobile-banner').insertBefore('.page-faqhomepage .main-content .row-fluid.bloc-light');
        $('.page-CSSRepairersWithMap .row-fluid.bloc-light .span9 > .faq-banner div.picture').addClass('mobile-banner').insertBefore('.page-CSSRepairersWithMap .main-content > .row-fluid.bloc-light');
    }

    /**
     *
     */
    $('.list-product .range .list-content .thumbnail img').each(function () {
        $(this).wrap("<div class='img-container'></div>");
    });

    /**
     *
     */
    $('.scroll-anchor ul li a').on('click',function () {
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top - ($('.wrap-header').height() + 20)
        }, 500);
        return false;
    });

    /**
     *
     */
    /* RRF-160 BRA-3925 */
    if ($('body').hasClass('page-AccessoriesHomePage')) {
        $('.bx-wrapper').addClass('simpleSlider-wrapper');
    }
    /* RRF-160 BRA-3925 */

    /**
     *
     */
    // Push banner
    if ($(document).width() <= 1024) {
        NavDeplacePush();
    }

    /**
     *
     * @type {boolean}
     */
    var isiPad = /ipad/i.test(navigator.userAgent.toLowerCase());

    /**
     *
     */
    if (isiPad) {
        NavDeplacePush();
    }

    /* BSCU-5 */
    if($.trim($(".product-interest").html())==''){
        $(".product-interest").remove();
    }

});

/**
 *
 */
$(window).on('scroll',function () {
    if ($(this).scrollTop() > 85) $('body').addClass("mini-header");
    else $('body').removeClass("mini-header");
});

/**
 *
 * @constructor
 */
function NavDeplacePush() {
    $('.main-nav .navigation a').on('click', function () {
        if ($(this).next().hasClass('open')) {
            $(this).next().find('.col:first-child .item').appendTo('.col:last-child');
        }
    });
}

/**
 *
 */
//Product Detail - Array product comparision
function scrollableTable() {
    /**
     *
     * @type {Number}
     */
    var nbvisible = parseInt(jQuery('.scrollableTable').attr('data-visible'));
    jQuery('.scrollableTable').hide();
    jQuery('.scrollable-control[data-slide="prev"]').addClass('disabled');
    jQuery('.scrollableTable th:not(.info), .scrollableTable td:not(.info), .scrollableTable:not(.nohover) td').each(function () {
        jQuery(this).hide();
        jQuery(this).hover(function () {
            jQuery(this).toggleClass('on');
            var colnum = jQuery(this).parent('tr').children('.on').index();
            if (colnum > 0) {
                jQuery('.scrollableTable tr').each(function () {
                    jQuery(this).children(':eq(' + colnum + ')').addClass('on');
                });
            } else {
                jQuery('.on').removeClass('on');
            }
        });
    });
    jQuery('.scrollableTable .info').show();
    for (var i = 1; i <= nbvisible; i++) {
        jQuery('.scrollableTable tr').each(function () {
            jQuery(this).children('th:eq(' + i + '), td:eq(' + i + ')').show().addClass('active');
        });
    }
    jQuery('.scrollable-control').on('click', function () {
        /**
         *
         * @type {scrollableTable}
         */
        var button = this;
        jQuery(button).hide();
        jQuery('.scrollableTable tr').each(function () {
            /**
             *
             * @type {scrollableTable}
             */
            var thisLine = this;
            if (jQuery(button).attr('data-slide') == 'next') {
                if (jQuery(this).children('th.active:not(.info), td.active:not(.info)').last().next().length > 0) {
                    jQuery('.scrollable-control[data-slide="prev"]').removeClass('disabled');
                    /**
                     *
                     */
                    var nextObj = jQuery(this).children('th.active:not(.info), td.active:not(.info)').last().next();
                    jQuery(this).children('th.active:not(.info), td.active:not(.info)').first().hide('slide', {direction: "left"}, 'fast', function () {
                        nextObj.show('slide', {direction: "right"}, 'fast').addClass('active');
                        jQuery(button).show(function () {
                            if (jQuery(thisLine).children('.active:not(.info)').last().next().length == 0) {
                                jQuery(button).addClass('disabled');
                            }
                        });
                    }).removeClass('active');
                } else {
                    jQuery(button).addClass('disabled');
                    jQuery(button).show();
                }
            } else {
                if (jQuery(this).children('th.active:not(.info), td.active:not(.info)').first().prevUntil('.info').length > 0) {
                    jQuery('.scrollable-control[data-slide="next"]').removeClass('disabled');
                    /**
                     *
                     */
                    var prevObj = jQuery(this).children('th.active:not(.info), td.active:not(.info)').first().prev();
                    jQuery(this).children('th.active:not(.info), td.active:not(.info)').last().hide('slide', {direction: "right"}, 'fast', function () {
                        prevObj.show('slide', {direction: "left"}, 'fast').addClass('active');
                        jQuery(button).show(function () {
                            if (jQuery(thisLine).children('.active:not(.info)').first().prev(':not(.info)').length == 0) {
                                jQuery(button).addClass('disabled');
                            }
                        });
                    }).removeClass('active');
                } else {
                    jQuery(button).addClass('disabled');
                    jQuery(button).show();
                }
            }
        });
    });
    if (jQuery('.scrollableTable table tbody tr:first-child td:not(.info,.reference)').length < nbvisible) {
        jQuery('.scrollableTable .scrollable-control').hide();
    }

    jQuery('.scrollableTable').show();
}

/**
 *
 */
//Ajout classe 'float' to 'zone-compare' mobile
$(window).on('scroll',function () {
    if (isMobile == true) {
        if ($(this).scrollTop() > 250) $('.zone-compare').addClass("float");
        else $('.zone-compare').removeClass("float");
    }
});

/**
 *
 */
function refresh_compare() {
    if ($(".gocompare").length < 2) {
        $(".gocompare").hide();
    }
}

if(!isMobile){
    $('.gocompareBtn').hide('fast');
} else if(isMobile && countGoCompare() > 1){
    $('.gocompareBtn').show('fast');
} else {
    $('.gocompareBtn').hide('fast');
}

/**
 * Product Comparator
 */
function initGoCompare(maxCheckError) {
    // countCompare();
    jQuery('.gocompare')
        .each(
            function () {
                if ((jQuery(this).children('input').is(':checked'))
                    && (jQuery('.gocompare input[type=checkbox]:checked').length > 1)) {
                    jQuery(this).addClass('active');
                } else {
                    jQuery(this).removeClass('active');
                }
            });
    jQuery('.gocompare input[type=checkbox]').on('click',
        function () {
            if ((!isMobile && countGoCompare() < 5)||(isMobile && countGoCompare() < 3)) {
                playGoCompare(jQuery(this));
            } else {
                if(isMobile){
                    maxCheckError = maxCheckError.replace("4","2");
                }
                $("#ModalMessage .modal-body").html(
                    '<p>' + maxCheckError + '</p>');
                $("#ModalMessage").show();
                $("#ModalMessage").modal();
                $("#ModalMessage").on('hidden.bs.modal', function () {
                    $("#ModalMessage .modal-body").html("");
                    $("#ModalMessage").removeClass("modal-business");
                });
                return false;
            }
            $(".gocompare input[type=checkbox]").trigger( "check" );
        });
}
function countGoCompare() {
    return jQuery('.gocompare input[type=checkbox]:checked').length;
}
function playGoCompare(checkbox) {
    if (checkbox.is(':checked')) {
        if (jQuery('.gocompare input[type=checkbox]:checked').length > 1) {
            checkbox.parent('label').addClass('active');
            jQuery('.gocompare input[type=checkbox]:checked').parent('label')
                .addClass('active');
            if(isMobile){
                $('.gocompareBtn').show('fast');
            }
        } else {
            jQuery('.gocompare input[type=checkbox]:checked').parent('label')
                .removeClass('active');
            $('.gocompareBtn').hide('fast');
        }
    } else {
        // checkbox.parent('label').removeClass('active');
        if (jQuery('.gocompare input[type=checkbox]:checked').length > 1) {
            jQuery('.gocompare input[type=checkbox]:checked').parent('label')
                .addClass('active');
            if(isMobile){
                $('.gocompareBtn').show('fast');
            }
        } else {
            jQuery('.gocompare input[type=checkbox]:checked').parent('label')
                .removeClass('active');
            $('.gocompareBtn').hide('fast');
        }
        checkbox.parent('label').removeClass('active');
    }
}
/**
 * End product Comparator
 */

/**
 *
 * @param msg
 * @param type
 * @returns {boolean}
 */
function notification(msg, type) {
    $('#globalMessages').empty().append("<div class='information_message " + type + "'><span class='single'></span><p>" + msg + "</p></div>");
    $('html,body').animate({
        scrollTop: $('#globalMessages').offset().top - 63
    }, 500);
    return false;
}

/**
 *
 */
function killNotification() {
    $('#globalMessages').empty();
}

/**
 *
 */
/* Autocomplete Highlight function */
function HighlightAutocomplete() {
    $.ui.autocomplete.prototype._renderItem = function (ul, item) {
        /**
         *
         * @type {RegExp}
         */
        var re = new RegExp("^" + this.term, "i");
        /**
         *
         */
        var t = item.label.replace(re, "<span style='font-weight:bold;'>" + this.term + "</span>");
        return $("<li></li>")
            .data("item.autocomplete", item)
            .append("<a>" + t + "</a>")
            .appendTo(ul);
    };
}

/**
 *
 */
/* Loader Handler */
function hideLoader() {
    $('.loader').fadeOut("fast", function () {
        $('.loader').css('display', 'none');
    });
}

/**
 *
 */
function showLoader() {
    $('.loader').css('display', 'block').fadeIn("slow");
}

/**
 *
 */
//Scrollables lame management
function scrollableLames() {
    jQuery('.scrollable-lame').each(function () {
        /**
         *
         * @type {scrollableLames}
         */
        var thisLame = this;

        /**
         *
         */
        var lameAttr;
        if ($(document).width() >= 1024) {
            lameAttr = 3
        } else if ($(document).width() >= 510) {
            lameAttr = 2
        } else {
            lameAttr = 1
        }
        /**
         *
         */
        var nbvisible = lameAttr;
        if (jQuery(thisLame).find('.item').length > nbvisible) {
            jQuery(thisLame).find('.item').fadeOut();
            jQuery(thisLame).find('.lame-control[data-slide="prev"]').addClass('disabled');
            for (var i = 0; i < nbvisible; i++) {
                jQuery(thisLame).find('.item:eq(' + i + ')').fadeIn().addClass('visible');
            }
            jQuery(thisLame).find('.lame-control').on('click touchstart', function () {
                /**
                 *
                 * @type {scrollableLames}
                 */
                var button = this;
                jQuery(button).fadeOut();
                if (jQuery(button).attr('data-slide') == 'next') {
                    if (jQuery(thisLame).find('.visible').last().next().length > 0) {
                        jQuery(thisLame).find('.lame-control[data-slide="prev"]').removeClass('disabled');
                        /**
                         *
                         */
                        var nextObj = jQuery(thisLame).find('.visible').last().next();
                        jQuery(thisLame).find('.visible').first().fadeOut('300', function () {
                            nextObj.fadeIn('300').addClass('visible');
                            $(button).fadeIn(function () {
                                if (jQuery(thisLame).find('.visible').last().next().length == 0) {
                                    jQuery(button).addClass('disabled');
                                }
                            });
                        }).removeClass('visible');
                    } else {
                        jQuery(button).addClass('disabled');
                        $(button).fadeIn();
                    }
                } else {
                    if (jQuery(thisLame).find('.visible').first().prev().length > 0) {
                        jQuery(thisLame).find('.lame-control[data-slide="next"]').removeClass('disabled');
                        /**
                         *
                         */
                        var prevObj = jQuery(thisLame).find('.visible').first().prev();
                        jQuery(thisLame).find('.visible').last().fadeOut('300', function () {
                            prevObj.fadeIn('300').addClass('visible');
                            jQuery(button).fadeIn(function () {
                                if (jQuery(thisLame).find('.visible').first().prev().length == 0) {
                                    jQuery(button).addClass('disabled');
                                }
                            });
                        }).removeClass('visible');
                    } else {
                        jQuery(button).addClass('disabled');
                        jQuery(button).fadeIn();
                    }
                }
            });
            jQuery(thisLame).show();
        } else {
            jQuery(thisLame).find('.lame-control').fadeOut();
        }
    });
}

/**
 *
 * @param form
 * @param update
 */
function incrementQuantity(form, update) {
    /**
     *
     */
    var obj = jQuery(form).find('#quantity');
    /**
     *
     * @type {Number}
     */
    var qty = parseInt(obj.val());
    obj.val(qty + 1);
    if (update == true) {
        jQuery(form).trigger('submit');
    }
}

/**
 *
 * @param form
 * @param update
 */
function decrementQuantity(form, update) {
    /**
     *
     */
    var obj = jQuery(form).find('#quantity');
    /**
     *
     * @type {Number}
     */
    var qty = parseInt(obj.val());
    if (qty > 1) {
        obj.val(qty - 1);
        if (update == true) {
            jQuery(form).trigger('submit');
        }
    }
}

/**
 *
 * @param form
 * @param max
 * @param update
 */
function incrementQuantityForAcc(form, max, update) {
    /**
     *
     */
    var obj = jQuery(form).find('#qty');
    /**
     *
     * @type {Number}
     */
    var qty = parseInt(obj.val());
    if (qty < max) {
        obj.val(qty + 1);
        if (update == true) {
            jQuery(form).trigger('submit');
        }
    } else {
        jQuery(form).find('#msg_error').show();
    }
}

/**
 *
 * @param form
 * @param update
 */
function decrementQuantityForAcc(form, update) {
    /**
     *
     */
    var obj = jQuery(form).find('#qty');
    /**
     *
     * @type {Number}
     */
    var qty = parseInt(obj.val());
    jQuery(form).find('#msg_error').hide();
    if (qty > 1) {
        obj.val(qty - 1);
        if (update == true) {
            jQuery(form).trigger('submit');
        }
    }
}

/**
 *
 * @param msg
 */
function confirmDeleteEntry(msg) {
    return confirm(msg);
}

/**
 *
 */
function handleMoulisearchLoad() {
    $(document).on('click', '.wrap-product-list .show-more a', function (event) {
        $('.show-more').hide();
        event.preventDefault();
        /**
         *
         * @type {*|jQuery}
         */
        var url = $(this).attr("href");
        showLoader();
        $.ajax({
            url: url,
            type: 'GET',
            dataType: 'html',
            data: ''
        }).always(function (data) {
          $('.product-list').append(data);
          hideLoader();
        });
    });
}

/**
 *
 */
/* funciton TEFAL */
function LoadMore(obj) {
    jQuery(obj).parents('.see-more').hide();
    jQuery.ajax({
        url: jQuery(obj).attr('href')
    }).done(function (html) {
        jQuery(obj).parents(".list-content").find(".item").remove();
        jQuery(obj).parents(".list-content").html(html);
        initGoCompare();
        refresh_compare();
    });
}

/**
 *
 */
/* ajax for load more results for search single and multiple */
function LoadMoreResults(obj, seeAll, idName) {
    seeAll = typeof seeAll !== 'undefined' ? seeAll : false;
    jQuery(obj).parents('.see-more').remove();
    /**
     *
     * @type {string}
     */
    var id = '#' + idName;
    if (seeAll == true) {
        jQuery.ajax({
            url: jQuery(obj).attr('href')
        }).done(function (html) {
            $(id).html(html).slideDown('slow', 'linear');
        });
    } else {
        jQuery.ajax({
            url: jQuery(obj).attr('href')
        }).done(function (html) {
            $(id).html($(id).html() + html).slideDown('slow', 'linear');
        });
    }
}

/**
 *
 */
$('.product-comparator .close').on('click', function () {
    /**
     *
     * @type {number}
     */
    var i = 0;
    $('.scrollableTable tr th').each(function () {
        i++;
    });
    if (i > 3) {
        /**
         *
         * @type {*|jQuery}
         */
        var colnum = $(this).parent().parent().index();
        if (colnum > 0) {
            $('.scrollableTable tr').each(function () {
                $(this).children(':eq(' + colnum + ')').remove();
            });
            /**
             *
             * @type {*|jQuery}
             */
            var w_table = $('#ScrollabeTableCompare').width();
            $('#ScrollabeTableCompare td, #ScrollabeTableCompare th').css('width', 240);
        }
        if (i == 4) {
            $('.scrollableTable .close').fadeOut();
        }
    }
});

/**
 *
 */
function hideClassificationInrRowFilterMode() {
  $('.product-comparator #ScrollabeTableCompare tr.comparison').each(function(){
    var first = $(this);
    var next = first.next();
    var count = 0;
    while(next.length>0 && !next.hasClass("comparison")) {
      if(!next.hasClass("ressemblant")) {
        count++;
      }
      next = next.next();
    }
    if(count === 0) {
      first.hide();
    }
  });
}
$('.product-comparator .facet_block-label input').on('change', function () {
    /**
     *
     * @type {number|jQuery}
     */
    var is_checked = $(".product-comparator .facet_block-label input:checked").length;
    if (is_checked == 0) {
        $('.product-comparator #ScrollabeTableCompare tr').show();
    }
    else {
        $('.product-comparator #ScrollabeTableCompare tr.ressemblant').hide();
        hideClassificationInrRowFilterMode();
    }
});

/**
 *
 */
function bindForm() {
    $('#new_address_form').on('change', function () {
        /**
         *
         * @type {*|jQuery}
         */
        var url_address = $("#add-address-button").attr("data-ajax");

        /**
         *
         * @type {*|jQuery}
         */
        var isoCode = $('#new_address_form').val();
        jQuery.ajax({
            type: "GET",
            url: url_address,
            data: {country: isoCode}
            //data: "id=" + id, // appears as $_GET['id'] @ ur backend side
        }).done(function (data) {
            // data is ur summary
            $('#AddressManager').html(data);
            bindForm();
        }).always( function (data) {
            jQuery('#AddressManager').slideDown();
        });
    });
}

/**
 *
 * @param obj
 */
function gsebAddressManager(obj) {
    $('#AddressManager').slideUp('fast', function () {
        /**
         *
         * @type {*|jQuery}
         */
        var url_address = $(obj).attr('data-ajax');
        $.ajax({
            type: "GET",
            url: url_address
            //data: "id=" + id, // appears as $_GET['id'] @ ur backend side
        }).done( function (data) {
            try {
                data = JSON.parse(data)
            } catch (e) {
                //Temporary FIX for malformed JSON with escape single quotes
                data = data.replace(/\\'/g, "'");
                try {
                    data = JSON.parse(data);

                } catch (e) {
                }
            }
            $('#AddressManager').html(data.validatedForm);
            bindForm();
            bindCreateUpdateAddress();
        }).always( function (data) {
            $('#AddressManager').show();
            scrollToParam('#AddressManager');
        });
    });
}

/**
 *
 */
function bindCreateUpdateAddress() {
  $('.create_update_address_form').on('submit', function(event){
    event.preventDefault();
    $.ajax({
      url: ACC.config.contextPath + $(this).prop('action'),
      data: $(this).serialize() + '&' + $(this).find("button[type=submit]").prop('name'),
      method: $(this).prop('method')
    }).done(function (data) {
      try {
        data = JSON.parse(data)
      } catch (e) {
        //Temporary FIX for malformed JSON with escape single quotes
        data = data.replace(/\\'/g, "'");
        try {
          data = JSON.parse(data);

        } catch (e) {
          //console.log("Parse JSON ERROR");
        }
      }
      $(".addrFormContainer").html(data.validatedForm);
      $("#globalMessages").html(data.message);
      bindCreateUpdateAddress();
      if (data.success == 'true') {
        var addEditText=$(".addressAddEditTxt").clone();
        $(".addrBookContainer").html(data.addrBook);
        $(".addrBookContainer").prepend($(addEditText));
        closeGsebAddressManager();
      }
    });
  });
}

/**
 *
 * @param param
 */
function scrollToParam(param) {
    /**
     *
     * @type {Number}
     */
    var place = parseInt($(param).offset().top);
    $('html,body').animate({
        scrollTop: place - 63 // -63 pour prendre en compte le header fixe
    }, 600);
}

/**
 *
 */
function closeGsebAddressManager() {
    scrollToParam('body');
    $('#AddressManager').html("");
    appendDeliveryAddress();
    appednAddrBookContainer();
}

/**
 *
 */
function closeAddressManager() {
    $('#AddressManager').slideUp();
}

/**
 *
 * @param obj
 * @param msg
 */
function confirmDelete(obj, msg) {
    if (confirm(msg)) {
        console.log('you accept : reload the page.');
        return true;
    }
    return false;
}

/**
 *
 */
$("#FormNewsLetter").on('submit',function (event) {
    event.preventDefault();
});

/**
 *
 */
function showNewsLetterModalIncheckoutPage() {
    $(".skip[id^=error]").hide();
    /**
     *
     * @type {boolean}
     */
    var termsNotChecked = !jQuery('#rules').is(':checked');

    /**
     *
     * @type {boolean}
     */
    var paymentNotChecked = !jQuery('input[id^=payment-mode-]').is(':checked');

    /**
     *
     * @type {boolean}
     */
    var stopProcessing = false;

    if (termsNotChecked) {
        jQuery('#errorTOS').show();
        stopProcessing = true;
    }
    if (isSampleOrder===false && paymentNotChecked) {
        jQuery('#errorPM').show();
        stopProcessing = true;
    }else{
        jQuery('#errorPM').hide();
    }
    if ($('#detachedPieceCG').length > 0 && !$('#detachedPieceCG').is(':checked')) {
        $('#errorCG-PD').show();
        stopProcessing = true;
    }
    else {
        $('#errorCG-PD').hide();
    }
    if ($('#repareServiceCG').length > 0 && !$('#repareServiceCG').is(':checked')) {
        $('#errorCG-RS').show();
        stopProcessing = true;
    } else {
        $('#errorCG-RS').hide();
    }
    if(!validateLegalTax()){
        stopProcessing=true;
    }
    if(!validateMobilePhone()){
        stopProcessing=true;
    }
    if (stopProcessing) {
        return;
    }
    $('#ModalNewsLetter').modal();
    Modal.show();
}

/**
 *
 */
// incription � la newsLetter apr�s la cr�ation du compte
if ($("#ModalNewsLetter.my-space").length > 0) {
    $('#ModalNewsLetter.my-space').modal();
    Modal.show();
}

//Show Paylib message
$("#FormPaymentMode input[type=radio][id*=payment-mode-]").on('click', function(){
    if( $("#FormPaymentMode input[type=radio][id*=payment-mode-][value*=paylib]").is(':checked') )
        $("#paylibMessage").show();
    else
        $("#paylibMessage").hide();
});


function submitNewsletter(){
    $.ajax({
        type: $("#FormNewsLetter").attr('method'),
        data: $("#FormNewsLetter").serialize(),
        url: $("#FormNewsLetter").attr('action')
    }).done( function (data) {
        if(data == "ok") {
            $("#popinMessages").append("<div class='information_message positive'> <span class='single'></span> <span> "+newsLEtterSubscribeEmail+"</span> </div>");
            $("#FormNewsLetter .item-form-news").remove();
            $("#DoubleOptinButton").remove();
            $("#DoubleOptinButtonClose").show("#DoubleOptinButton");
        }else {
            $("#DoubleOptinButtonClose").trigger('click');
        }
    }).fail( function () {
        $('#errorSubscription').show();
    });
    $("#FormNewsLetter").trigger('submit');
}

 

function validateTOSForDoubleOptin(url) {
    $(".skip[id^=error]").hide();
    if ($('#rules').is(':checked') && ( $('#detachedPieceCG').length <= 0 || $('#detachedPieceCG').is(':checked')) && ($('#repareServiceCG').length <= 0 || $('#repareServiceCG').is(':checked')) && (jQuery('input[id^=payment-mode-]').length <= 0 || jQuery('input[id^=payment-mode-]').is(':checked')) && validateLegalTax() && validateMobilePhone()) {

        if(isSampleOrder===true){
            placeSmapleOrder();
        }else{
            //go create the order
            validateTOSAjaxService(url);
        }

    } else {
        if (!$('#rules').is(':checked')) {
            $('#errorTOS').show();
        }
        else {
            $('#errorTOS').hide();
        }
        if ($('#detachedPieceCG').length > 0 && !$('#detachedPieceCG').is(':checked')) {
            $('#errorCG-PD').show();
        }
        else {
            $('#errorCG-PD').hide();
        }
        if ($('#repareServiceCG').length > 0 && !$('#repareServiceCG').is(':checked')) {
            $('#errorCG-RS').show();
        } else {
            $('#errorCG-RS').hide();
        }
        if(jQuery('input[id^=payment-mode-]').length > 0 && !jQuery('input[id^=payment-mode-]').is(':checked')) {
            jQuery('#errorPM').show();
        }
        validateLegalTax();
        validateMobilePhone()
        if(isSampleOrder===false){
            var legalTaxNumber=$("#legal-tax-number").val();
            var legalTaxNumberData=typeof legalTaxNumber !== 'undefined'?"&legal-tax-number="+legalTaxNumber:'';
            var mobilePhone=$("#mobilePhone").val();
            var mobilePhoneData=typeof mobilePhone !== 'undefined'?"&mobilePhone="+mobilePhone:'';
            $.ajax({
                type: "post",
                data: $("#FormPaymentMode").serialize()+legalTaxNumberData+mobilePhoneData,
                url: url
            }).done( function (data) {
                $('#errorPM').hide();
            }).fail( function () {
                $('#errorPM').show();
            });
        }
    }
    $('#ModalNewsLetter').find('.close').trigger("click");
}

function validateTOS(url) {
    $(".skip[id^=error]").hide();
    if ($('#rules').is(':checked') && ( $('#detachedPieceCG').length <= 0 || $('#detachedPieceCG').is(':checked')) && ($('#repareServiceCG').length <= 0 || $('#repareServiceCG').is(':checked')) && (jQuery('input[id^=payment-mode-]').length <= 0 || jQuery('input[id^=payment-mode-]').is(':checked')) && validateLegalTax() && validateMobilePhone()) {
        /*il faut d'abord verifier si la case � cocher existe avant de v�rfier s'il est coch�e
         * parce que cette case � cocher n'apparait sauf si il y'a un produit de type X
         */
        //update news letter data
        $.ajax({
            type: $("#FormNewsLetter").attr('method'),
            data: $("#FormNewsLetter").serialize(),
            url: $("#FormNewsLetter").attr('action')
        });
        $("#FormNewsLetter").trigger('submit');

        if(isSampleOrder===true){
            placeSmapleOrder();
        }else{
            //go create the order
            validateTOSAjaxService(url);
        }


    } else {
        if (!$('#rules').is(':checked')) {
            $('#errorTOS').show();
        }
        else {
            $('#errorTOS').hide();
        }
        if ($('#detachedPieceCG').length > 0 && !$('#detachedPieceCG').is(':checked')) {
            $('#errorCG-PD').show();
        }
        else {
            $('#errorCG-PD').hide();
        }
        if ($('#repareServiceCG').length > 0 && !$('#repareServiceCG').is(':checked')) {
            $('#errorCG-RS').show();
        } else {
            $('#errorCG-RS').hide();
        }
        if(jQuery('input[id^=payment-mode-]').length > 0 && !jQuery('input[id^=payment-mode-]').is(':checked')) {
            jQuery('#errorPM').show();
        }
        validateLegalTax();
        validateMobilePhone();
    }
    $('#ModalNewsLetter').find('.close').trigger("click");
}

/**
 *
 */
function initScrollingStoreList() {
    //scroll store list
    if (isMobile == false) {
        $('.scroll-store').slimScroll({
            height: 400,//$('.actions').height(),
            alwaysVisible: true,
            allowPageScroll: false,
            position: 'right',
            color: '#00A3C6',
            opacity: 1,
            distance: 0,
            railVisible: true,
            wheelStep: 10,
            railColor: '#ffffff',
            railOpacity: 1
        });
    }
}

/**
 *
 * @param myPoint
 */
function gotoPoint(myPoint, posName) {
    google.maps.event.addListenerOnce(map, 'center_changed', function(event) {
        //set a minimum zoom
        // if you got only 1 marker or all markers are on the same spot
        if (this.getZoom() > 13) {
            this.setZoom(13);
        }
    });
    map.setCenter(new google.maps.LatLng(locations[myPoint][2], locations[myPoint][3]));
    setTimeout(function () {
        markerCollection[myPoint].setAnimation(null);
    }, '5000');
    //infowindow.close();
    for (j = 0; j < locations.length; j++) {
        markerCollection[j].setAnimation(null);
    }
    if (markerCollection[myPoint].getAnimation() != null) {
        markerCollection[myPoint].setAnimation(null);
    } else {
        markerCollection[myPoint].setAnimation(google.maps.Animation.BOUNCE);
    }
    showDetails(posName, myPoint);
    redimensionnerStore('#StoreLocator .details-store-off:visible');
}


/**
 *
 * @param selecteur
 */
function redimensionnerStore(selecteur) {
    /**
     *
     * @type {number}
     */
    var hauteur = 0;
    $(selecteur).each(function () {
        if ($(this).height() > hauteur) hauteur = $(this).height();
    });
    $(selecteur).each(function () {
        $(this).height(hauteur);
    });
}

/**
 *
 * @param reCaptchaPubKey
 * @param id
 */
function createReCaptcha(reCaptchaPubKey, id) {
    Recaptcha.create(reCaptchaPubKey, id, {
        theme: "clean"
    });
}

/**
 *
 */
if ($(".a2a_dd")) {//if Add2Any div exist on page , load js
    /**
     *
     * @type {{}|a2a_config}
     */
    var a2a_config = a2a_config || {};
    a2a_config.onclick = 1;
    a2a_config.prioritize = ["facebook", "twitter", "linkedin",
        "google_plus", "pinterest", "tumblr", "myspace", "email",
        "google_bookmarks", "yahoo_bookmarks"];
    a2a_config.num_services = 10;
    a2a_config.color_main = "D7E5ED";
    a2a_config.color_border = "D7E5ED";
    a2a_config.color_link_text = "373332";
    a2a_config.color_link_text_hover = "373332";
    (function (d, t) {
        /**
         *
         * @type {Element}
         */
        var g = d.createElement(t), s = d.getElementsByTagName(t)[0];
        g.src = '//static.addtoany.com/menu/page.js';
        s.parentNode.insertBefore(g, s);

    }(document, 'script'));
}

/**
 *
 * @param obj
 * @returns {boolean}
 */
function submitFormUser(obj) {
    /**
     *
     */
    var validForm = jQuery(obj).validationEngine('validate');
    if (validForm == true) {
        jQuery(obj).trigger('submit');
        StoreLocator
    } else {
        jQuery(obj).validationEngine({
            scroll: false
        });
    }
    return false;
}

/**
 *
 */
/*ajax for load more results store locator*/
function PaginationStore(obj) {
    //TO SIMULATE LOADING -- TO REMOVE WHEN AJAX IS READY
    jQuery.ajax({url: jQuery(obj).attr('href')}).done(function (html) {
        jQuery('#StoreLocator').html(html).slideDown('slow', 'linear');
        initScrollingStoreList();
    });
}

/**
 *
 * @param url
 */
function submitAlertEmailCreation(url) {
    /**
     *
     */
    var validForm = jQuery("#FormStockAlert").validationEngine('validate');
    if (validForm == true) {
        jQuery.ajax({
            type: "POST",
            data: jQuery("#FormStockAlert").find(
                "input[type='hidden'], :input:not(:hidden)").serialize(),
            url: url
        }).done( function (data) {
            jQuery("#FormStockAlert #globalMessages").html(data);
            if (jQuery("#globalMessages > .information_message").hasClass("positive")) {
                jQuery("#FormStockAlert").find('.first').remove();
                jQuery("#FormStockAlert").find('.last').show();
            }
        }).fail( function () {
            jQuery("#FormStockAlert #globalMessages").html(errorLogin);
        });
    }
}

/**
 *
 */
var Field = (function () {
    // Constructor
    /**
     *
     * @param name
     * @param order
     * @param type
     * @param rules
     * @param visible
     */
    var cls = function (name, order, type, rules, visible) {
        this.name = name; // Name of field
        this.order = order; // Dropdown lists steps values combination
        this.type = type; // Profile name
        this.rules = rules; // validation rules
        this.visible = visible; // is field visible by default
    };
    // Public methods
    cls.prototype = {
        getName: function () {
            return this.name;
        },
        getOrder: function () {
            return this.order;
        },
        getRules: function () {
            return this.rules;
        },
        isVisible: function () {
            return this.visible;
        },
        isMandatory: function () {
            return this.rules.indexOf("equired") >= 0;
        }
    };
    return cls;
})();

/**
 *
 */
/* RollOut Rowenta FR RRF-24 */
$(function () {
    /**
     *
     * @type {*|jQuery|HTMLElement}
     */
    var madeInRowentaList = $('.madeinrowenta ul li'); // get made in rowenta section's list items
    if (madeInRowentaList.length === 1) { // if list contains one element, clear float then center
        madeInRowentaList.css('float', 'none');
        madeInRowentaList.css('margin', '0 auto');
    }
});
/* RollOut Rowenta FR RRF-24 */

/**
 *
 */
/* RollOut Rowenta FR RRF-61 */
$(function () {
    // enjoy rowenta section
    /**
     *
     * @type {*|jQuery|HTMLElement}
     */
    var paragraphs = $('.enjoy-rowenta ul li .caption p:last-of-type');
    /**
     *
     * @type {Array}
     */
    var paragraphsLengths = [];
    /**
     *
     */
    var maxHeight;
    // get each paragraph height
    paragraphs.each(function (index, paragraph) {
        paragraphsLengths.push($(paragraph).height());
    });
    // get maximum height
    maxHeight = Math.max.apply(Math, paragraphsLengths);
    // set all paragraphs height to maxHeight
    paragraphs.each(function (index, paragraph) {
        $(paragraph).height(maxHeight);
    });
});
/* RollOut Rowenta FR RRF-61 */

/**
 *
 */
/* BRA-1770 */
$(function () {
    if (!(isMobile || !isTablet)) {
        $('#comparison table.table.table-condensed.floatThead-table').css('margin', '10px 0px 0px 0px');
    }
});
/* BRA-1770 */

/*Nav bar product details*/
/**
 *
 */
$(window).on('scroll',function () {
    /**
     *
     * @type {*|jQuery}
     */
    var position = $(window).scrollTop();

    /**
     *
     * @type {number}
     */
    var positionToFixeIn = $("#product-benefits").outerHeight() + $("#master-detail-product").outerHeight();

    if($("#productGammes").length) {
        positionToFixeIn+= $("#productGammes").outerHeight();
    }

    if ($(window).width() > 720) {
        positionToFixeIn += $(".wrap-header").outerHeight(true);
    }
    /**
     *
     * @type {number}
     */
    var postionTop = position - 120,
        postionDown = position + 135;
    if ($('.nav_lame').outerHeight(true) > 116) {
        postionTop = position - 191;
        postionDown = position + 206;
    }
    $('.nav_lame a').each(function () {
        /**
         *
         * @type {*|jQuery|HTMLElement}
         */
        var currLink = $(this);

        /**
         *
         * @type {*|jQuery|HTMLElement}
         */
        var refElement = $(currLink.attr("href"));
        if (refElement.position().top < postionDown && refElement.position().top + refElement.height() > postionTop) {
            $('.nav_lame  li a').removeClass("active");
            currLink.addClass("active");
        }
        else {
            currLink.removeClass("active");
        }
    });
    $('.nav_lame a:first').each(function () {
        /**
         *
         * @type {*|jQuery|HTMLElement}
         */
        var currLink = $(this);

        /**
         *
         * @type {*|jQuery|HTMLElement}
         */
        var refElement = $(currLink.attr("href"));
        if (refElement.position().top + refElement.height() > position + 100) {
            $('.nav_lame  li a').removeClass("active");
            currLink.addClass("active");
        }
    });
    if (position >= positionToFixeIn) {
        $(".nav_lame").addClass("fixed");
        if ($('.nav_lame').outerHeight(true) > 116)
            $("#product-description").addClass("padding-desc-mobile");
        else
            $("#product-description").addClass("padding-desc");
    }
    else {
        $(".nav_lame").removeClass("fixed");
        $("#product-description").removeClass("padding-desc");
        $("#product-description").removeClass("padding-desc-mobile");
    }
});

/**
 *
 */
// SCROLL on anchor click
$('.nav_lame li a').on('click',function () {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
        /**
         *
         * @type {*|jQuery|HTMLElement}
         */
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
            /**
             *
             * @type {number}
             */
            var scrollTopp = target.offset().top - 130;
            if ($('.nav_lame').outerHeight(true) > 116)
                scrollTopp = target.offset().top - 192;
            $('html,body').animate({
                scrollTop: scrollTopp
            }, 900);
            return false;
        }
    }
});

/**
 *
 */
function validateFormExplodedView() {
    if ($('#codeSav').val() != '') {
        if (document.getElementById('codeSav').validity.valid) {
            $('#errorInvalid').hide();
            $.ajax({
                type: $("#explodedViewsForm").attr('method'),
                data: $("#explodedViewsForm").serialize(),
                url: $("#explodedViewsForm").attr('action')
            }).done( function (data) {	//si l'action cot� serveur se termine corr�ctement
                //si la fonction return le code du Media exploded view on red�rige vers la fonction qui va afficher la page de la vue eclat�e
                if (data != null && data != '') {
                    //exploded-view/codeProduct/detail-exp-view/codeSAv
                    window.location.href = ACC.config.contextPath + "/exploded-view/" + $('#productCodePost').val() + "/detail-exp-view/" + data;
                }
                else {
                    $('#errorRequired').hide();
                    $('#errorNofound').show();
                }
            }).fail( function () {
                $('#errorRequired').hide();
                $('#errorNofound').show();
            });
        } else {
            $('#errorRequired').hide();
            $('#errorInvalid').show();
        }
    }
    else {
        $('#errorNofound').hide();
        $('#errorInvalid').hide();
        $('#errorRequired').show();
    }
}

/**
 *
 */
$("#explodedViewsForm").on('submit',function (event) {
    validateFormExplodedView();
    event.preventDefault();
});

/**
 *
 */
function validateFormDetachedPiece() {
    if ($('#accessoryCode').val() != '') {
        $.ajax({
            type: $("#detachedPieceForm").attr('method'),
            data: $("#detachedPieceForm").serialize(),
            url: $("#detachedPieceForm").attr('action')
        }).done( function (data) {	//si l'action cot� serveur se termine corr�ctement
            /*
             * si le code cat�gorisation diff�rent de "S" : Le client est redirig� vers la page d�tail produit de la pi�ce de rechange.
             *	La page d�tail de la pi�ce de rechange est identique � la page d'affichage d'un accessoire.
             */
            if (data != null && data != '') {
                if (data.accessoryCategorisation != 'S') {
                    window.location.href = ACC.config.contextPath + data.url;
                }
                else {
                    $('#errorRequired').hide();
                    $('#errorNofound').hide();
                    $('#errorNotForSale').show();
                    $('#modalErrorDetachedPiece').modal();
                    Modal.show();
                }
            } else {
                $('#errorRequired').hide();
                $('#errorNotForSale').hide();
                $('#errorNofound').show();

                $('#modalErrorDetachedPiece').modal();
                Modal.show();
            }
        }).fail( function () {
            $('#errorRequired').hide();
            $('#errorNotForSale').hide();
            $('#errorNofound').show();

            $('#modalErrorDetachedPiece').modal();
            Modal.show();
        });
    }
    else {
        $('#errorNotForSale').hide();
        $('#errorNofound').hide();
        $('#errorRequired').show();
    }
}

/**
 *
 */
// fonction ajout� pour handler le click sur le bouton entrer dans le formulaire de recherche des pieces detach�es
$("#detachedPieceForm").on('submit',function (event) {
    validateFormDetachedPiece();
    event.preventDefault();
});

/**
 *
 */
/* RRF-186 */
$(".made-in-rowenta").find(".caption").addClass("made-in-rowenta");

/**
 *
 */
/* BRA-5111 */
$(function () {
    /**
     *
     * @type {*|jQuery|HTMLElement}
     */
    var headers = $('.faq-topics-home .item h3'),
        /**
         *
         * @type {number}
         */
        truncateCharactersCountLimit = 53,
        /**
         *
         * @type {number}
         */
        truncateCharactersCountLimitAlt = 26,
        /**
         *
         * @type {number}
         */
        truncateLinesCountLimit = 3;
    headers.each(function () {
        /**
         *
         * @type {*|jQuery|HTMLElement}
         */
        var header = $(this);

        /**
         *
         */
        var headerHeight = header.height();

        /**
         *
         */
        var headerLineHeight = header.css('line-height').slice(0, header.css('line-height').length - 2);

        /**
         *
         * @type {number}
         */
        var linesCount = Math.round(headerHeight / headerLineHeight);
        if (header.text().length > truncateCharactersCountLimit) {
            /**
             *
             * @type {string}
             */
            var truncated = header.text().trim().substring(0, truncateCharactersCountLimit).split(' ').slice(0, -1).join(' ') + '…';
            header.text(truncated);
        }
        if (linesCount >= truncateLinesCountLimit) {
            /**
             *
             */
            var len = header.text().length;

            /**
             *
             */
            var truncated;

            /**
             *
             * @type {number}
             */
            var truncated_len = truncateCharactersCountLimit - 1;
            for (var i = 0; i < len; i++) {
                /**
                 *
                 */
                var headerHeight = header.height();

                /**
                 *
                 */
                var headerLineHeight = header.css('line-height').slice(0, header.css('line-height').length - 2);

                /**
                 *
                 * @type {number}
                 */
                var linesCount = Math.round(headerHeight / headerLineHeight);
                if (linesCount >= truncateLinesCountLimit) {
                    truncated = header.text().trim().substring(0, truncated_len).split(' ').slice(0, -1).join(' ') + '…';
                }
                else {
                    header.text(truncated);
                    return;
                }
                header.text(truncated);
            }
        }
    });
});
/* BRA-5115 */

$(function() {
    /**
     *  Placeholder fix
     */
    if (!Modernizr.input.placeholder) {
        $('[placeholder]').on('focus',function() {
            /**
             *
             * @type {*|jQuery|HTMLElement}
             */
            var input = $(this);
            if (input.val() == input.attr('placeholder')) {
                input.val('');
                input.removeClass('placeholder');
            }
        }).on('blur',function() {
            /**
             *
             * @type {*|jQuery|HTMLElement}
             */
            var input = $(this);
            if (input.val() == '' || input.val() == input.attr('placeholder')) {
                input.addClass('placeholder');
                input.val(input.attr('placeholder'));
            }
        }).trigger('blur');
        $('[placeholder]').parents('form').on('submit',function() {
            $(this).find('[placeholder]').each(function() {
                /**
                 *
                 * @type {*|jQuery|HTMLElement}
                 */
                var input = $(this);
                if (input.val() == input.attr('placeholder')) {
                    input.val('');
                }
            })
        });
    }
});

/*Start: BRA-5343 : Menu catégorie en sticky */
/**
 *
 * @type {number}
 */
var lastScrollTop = 0;

/**
 *
 */
$(window).on('scroll',function () {
    if ($(window).width() > 720) {
        /**
         *
         * @type {*|jQuery}
         */
        var st = $(this).scrollTop();

        /**
         *
         * @type {number}
         */
        var start = 0;

        /**
         *
         * @type {number}
         */
        var end = 0;

        /**
         *
         * @type {*|jQuery}
         */
        var menuHeight = $(".sub-nav").height();
        if ($("div.homePageMotion #video-banner").length > 0) {
            //pour le cas de la home page
            start = $("#video-banner").height() - $(".sub-nav").height() + 10;
            if ($(window).width() < 1023) {
                start = $(".bg-cover").height() + $(".sub-nav h2").height();
            }
            end = start;
        }
        if ($("#breadcrumb").length > 0) {
            end = $("#breadcrumb").height() - menuHeight;
        }
        if (start < 0) {
            start = 0;
        }
        if (st > lastScrollTop) {
            //downscroll
            if ($(window).scrollTop() >= start) {
                $('.sub-nav').addClass('fixed-menu');
                $('.wrap-breadcrumb').css("margin-top", menuHeight);
            }
            else {
                $('.sub-nav').removeClass('fixed-menu');
                $('.wrap-breadcrumb').css("margin-top", "0");
            }
        } else {
            //upscroll
            if ($(window).scrollTop() >= end + 10) {
                $('.sub-nav').addClass('fixed-menu');
                $('.wrap-breadcrumb').css("margin-top", menuHeight);
            }
            else {
                $('.sub-nav').removeClass('fixed-menu');
                $('.wrap-breadcrumb').css("margin-top", "0");
            }
        }
        if ($("#breadcrumb").length > 0) {
//    	pour gérer le cas de l'ajout de la class "mini-header"
            if (st < 85) {
                $('.fixed-menu').attr('style', 'margin-top: 10px !important');
            } else {
                $('.fixed-menu').attr('style', 'margin-top: 0 !important');
            }
        }
        lastScrollTop = st;
    }
});

/*End: BRA-5343 : Menu catégorie en sticky */

/** Transparent Modals */
$(function () {
    if ($('[id*="ModalMedia"]').length >= 1) {
        //console.log('At least one #ModalMedia present');
        $('[id*="ModalMedia"]').each(function () {
            var that = $(this);
            that.on('shown', function () {
                setTimeout(function () {
                    if (that.find('iframe').length === 1 && that.find('img').length <= 0) {
                        if($('.transparent-modal-close').length <= 1){
                            that.find('button.close').appendTo('.center-modal-iframe').wrap('<div class="transparent-modal-close"></div>');
                        }
                    } else {
                        that.removeClass('transparent-modal');
                    }
                }, 500);
            })
        });
    } else {
        //console.log('#ModalMedia NOT present');
    }
});
/** Transparent Modals */

//Stop modal video
$('.modal').on('hidden.bs.modal', function () {
    $(this).find('iframe').each(function() {
        this.contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*')
    });
})

//Masquer l'espace s'il n'y a pas de contenu
if (!$('#rowenta-storys .container').children().length) {
    $('#rowenta-storys').css('display', 'none');
}

/*
 * [BRA-12354] - CSS - vente de prestation standard de réparation
 */
function smoothScrollingTo(target, topOffset) {
  var $target = $(target);
  if ($(".add-service-popup").length > 0) {
    var $modalBody = $(".service-popup .modal-body");
    $modalBody.animate({
      scrollTop: $target.offset().top - $modalBody.offset().top + $modalBody.scrollTop()
    }, 500);
  } else {
    if ($target.offset()) {
      $('html,body').animate({scrollTop: ($target.offset().top) - (topOffset || 80)}, 500);
    }
  }
}

function emptyCoordinatesIfNoLocationQuery(url){
    if(!(new URL(url).searchParams.get("q"))) {
        $("#nearMeStorefinderForm #latitude").val('');
        $("#nearMeStorefinderForm #longitude").val('');
    }
}

function appendStoreLocatorAjaxResultToHTML(result){
    $('[id="repair-store-filter"]').html($(result).find("#repair-store-filter").html());
    $("#search-filter_repairs").replaceWith($(result).find("#search-filter_repairs").first());
    if($(".page-my-repairers").length) {
        $(".scroll-store").html($(result).find(".scroll-store").html());
    }
    $("#StoreLocator").html($(result).find("#StoreLocator").html());
    $('#cssRepairersMapFilter #StoreLocator > .repairs-filter-distance').hide();
    $('#cssRepairersMapFilter #StoreLocator > .d-none-sm').hide();
}

function pushStoreLocatorParamsToHistoryState(url) {
    var parser = document.createElement('a');
    parser.href = url;
    history.pushState({}, 'storeLocatorQueryParams', parser.search);
}

function Observable() {
    return $.extend(this, $.Deferred(), {
        next: function (value) {
            if (this.skip || this.skipAll) {
                this.skip = (value === 'skip')
                this.skipAll = this.skipAll && (value !== 'activate')
                return this
            }
            if (value === 'skip' || value === 'skipAll') {
                this[value === 'skip' || value === 'skipAll' ? value : 'isActive'] = true
                return this
            }
            return this.notify(value)
        },
        subscribe: function (callback) {
            return this.progress(function (value) {
                callback.call(this, value)
            })
        }
    })
}

function submitStoreLocatorFormWithAjax(form, method) {

    $("#StoreLocator").addClass("ajax-overlay");
    var addServiceUrl = "/consumer-services/warranty-and-repairs/repairers-popup";
    var addServicePopup = $("input[name='isAddServicePopup']").val();
    var isAddServicePopup = typeof addServicePopup !== 'undefined' ? addServicePopup : false;
    var submitUrl = isAddServicePopup ? addServiceUrl : [location.protocol, '//', location.host, location.pathname].join('');

    $.ajax({
        type: method,
        url: submitUrl,
        data: form.serialize()
    }).done( function (result, textStatus, jqXHR) {

        var $StoreLocator = $("#StoreLocator").removeClass("ajax-overlay");

        pushStoreLocatorParamsToHistoryState(isAddServicePopup ? this.url.substring(0, this.url.indexOf('?')) : this.url);

        appendStoreLocatorAjaxResultToHTML(result);

        initScrollingStoreList();
        if (isAddServicePopup) {
            $("#accessory-pointOfServiceName").val("");
        }
      setTimeout(function () {
        if($('#nearMeStorefinderForm').parents('#ModalMessage').length) {
          GSEB.functions.scrollinModal('#ModalMessage .modal-body', isMobile ? '#map-canvas' : '#nearMeStorefinderForm');
        }else{
          GSEB.functions.scrollTo(isMobile ? '#map-canvas' : '#nearMeStorefinderForm', $("header").height() + 10);
        }
      },500);
    }).fail( function (error) {
        $("#StoreLocator").removeClass("ajax-overlay");
        console.log(error);
    });
}

function getStoreLocatorFragment(link) {

    $.ajax({
        type: 'GET',
        url: link
    }).done( function (result, textStatus, jqXHR) {

        pushStoreLocatorParamsToHistoryState(this.url);

        appendStoreLocatorAjaxResultToHTML(result);

        initScrollingStoreList();

        if (isMobile) {
            $observables.storeLocatorObservables.next('storeLocatorRendering')
        }
    }).fail( function (error) {

        console.log(error);

    });
}

$(document).on('click', 'a.pos-feature-link[href^=\\#]', function(event){
    event.preventDefault();
    smoothScrollingTo(this.hash.replace("#","#pos-"));
    var pos_details_block_id = this.hash.replace("#","");
    $("[id^=ShopDetail-]").removeClass("pos-info-block-glow");
    $("[id^=ShopDetail-"+pos_details_block_id+"]").addClass("pos-info-block-glow activate").delay(1000).queue(function(){
        $(this).removeClass("activate").dequeue();
    });
});

$(document).ready(function(){
    if(isMobile && !$.trim($(".page-CSSRepairersWithMap div.mobile-banner").html())){
        $(".page-CSSRepairersWithMap div.mobile-banner").css("height","0");
        $(".page-CSSRepairersWithMap div.mobile-banner").css("margin-top","20px");
    }
});

window.addEventListener('popstate', function (event) {

    if($("#StoreLocator").length && !window.location.hash) {
        var url = [location.protocol, '//', location.host, location.pathname, location.search].join('');

        $("#StoreLocator").addClass("ajax-overlay");

        $.ajax({
            type: 'GET',
            url: url
        }).done( function (result, textStatus, jqXHR) {

            $("#StoreLocator").removeClass("ajax-overlay");

            emptyCoordinatesIfNoLocationQuery(url);

            appendStoreLocatorAjaxResultToHTML(result);

            initScrollingStoreList();

        }).fail( function (error) {

            $("#StoreLocator").removeClass("ajax-overlay");

            console.log(error);

        });
    }
});

/**
 * JS RCU
 */

// Login iFrame loader
// Login iFrame loader
(function($) {
    $.fn.bmdIframe = function( options ) {
        var settings = $.extend({
            classBtn: '.bmd-modalButton'
        }, options );

      $(document)
        .on("click", settings.classBtn, function(e) {
            // Redirect to full page in case of IE11 or Mobile
            if (GetIEVersion() > 0 && GetIEVersion() <= 11 || isMobile) {
                var linkRedirect = $(this).attr('data-bmdSrc');
                window.location.href = linkRedirect;

            }

            var allowFullscreen = $('.bmd-modalButton').attr('data-bmdVideoFullscreen') || false;

            var attrs = {
                'src': $('.bmd-modalButton').attr('data-bmdSrc')
            };

            if ( allowFullscreen ) attrs.allowfullscreen = "";

            $('.bmd-modalContent [name="login-iframe-item"]').attr(attrs);
            $('.bmd-modalContent [name="login-iframe-item"]').iFrameResize({autoResize : true});

            if(!$(this)[0].hasAttribute("data-toggle") && $(this)[0].hasAttribute("data-bmdsrc")) {
              jQuery("#rcuLoginModal").modal();
            }



        });

        this.on('hidden.bs.modal', function(){
            $(this).find('iframe').html("").attr("src", "");
        });

        return this;
    };

})(jQuery);

jQuery(document).ready(function(){
    jQuery("#rcuLoginModal").bmdIframe();
    $('.bmd-modalContent [name="login-iframe-item"]').css('min-height','500px');
    $('[name="iframe-item"]').iFrameResize({autoResize : true, heightCalculationMethod : 'lowestElement'});
    $('[name="iframe-item"]').css('margin-bottom','50px');

    /*Remove modal target to disable login popup in IE or Mobile*/
    if (GetIEVersion() > 0 && GetIEVersion() <= 11 || isMobile) {
        $("[data-target=\\#rcuLoginModal]").prop( "data-target", false );
    }
    /* BRA-21111 - 547771 [SDM - RCU] Problème de time out web */
    var isAutoLoadRCUPopup = $('.bmd-modalButton-auto');
    if(isAutoLoadRCUPopup){
        $('.bmd-modalButton-auto').trigger('click');
    }
});

//Handle Intelligent Tracking Prevention issue for Safari
(function($) {
    if(isRcuActivated){
        var ua = navigator.userAgent.toLowerCase();
        if (ua.indexOf('safari') != -1 ) {
            if (ua.indexOf('chrome') > -1) {
                console.log("Do nothing");
            } else {
                console.log("Handle the ITP");
                if ($.cookie("rcuFirstVisit") != "true") {
                    $.cookie("rcuFirstVisit", "true");
                    window.location.replace(sfRedirectTLPUrl);
                }
            }
        }
    }
})(jQuery);

//IP-536 : Logout after anonymisation
(function ($) {
    // Listen to messages sent from the content iframe
    var receiveMessage = function receiveMessage(e) {
        var currentUrl = window.location.href,
            url_parts = currentUrl.split("/"),
            baseUrl = url_parts[0] + "//" + url_parts[2];

        // Handle the message
        switch (e.data) {
            case 'salesforce_accountDeleted':
            {
                //Screen goes back to the deletion confirmation message.
                var $iFrameResizer0 = $('#iFrameResizer0');

                if ($iFrameResizer0.length){
                  $("html, body").animate({
                    scrollTop: $($iFrameResizer0).offset().top - 150
                  }, 500);
                }
                var delay = 5000;
                if (typeof rcuAccountDeletionDelay !== 'undefined') {
                    delay = rcuAccountDeletionDelay;
                }
                window.setTimeout(function () {
                    window.location.replace(baseUrl + "/logout");
                }, delay);

                break;
            }
        }
    };
    window.addEventListener("message", receiveMessage, false)
})(jQuery);


//IP-842 scroll handling
(function($) {
    var receiveMessage = function receiveMessage(e){
        // Handle the message
        switch (e.data) {
            case 'salesforce_actionbutton': case 'salesforce_newpageload': {
            if($('#rcuLoginModal').hasClass('in')) {
                $('#rcuLoginModal').animate({scrollTop: 0}, 250);
            } else {
                $("html, body").animate({scrollTop: 0}, 250);
            }
            break;
        }
        }
    };
    window.addEventListener("message", receiveMessage, false)
})(jQuery);


//IP-799 : Logout after updating password
(function($) {

    // Listen to messages sent from the content iframe
    var receiveMessage = function receiveMessage(e){
        var currentUrl = window.location.href,
            url_parts = currentUrl.split("/"),
            baseUrl = url_parts[0] + "//" + url_parts[2];

        if (currentUrl.indexOf("my-account") >= 0){
            // Handle the message
            switch (e.data) {
                case 'salesforce_login': {
                    console.log("Logout the current user");
                    window.location.replace( baseUrl + "/logout");
                    break;
                }
            }
        }
    };

    window.addEventListener("message", receiveMessage, false);

})(jQuery);

//Get IE Version
function GetIEVersion() {
    var sAgent = window.navigator.userAgent;
    var Idx = sAgent.indexOf("MSIE");

    // If IE, return version number.
    if (Idx > 0)
        return parseInt(sAgent.substring(Idx+ 5, sAgent.indexOf(".", Idx)));

    // If IE 11 then look for Updated user agent string.
    else if (!!navigator.userAgent.match(/Trident\/7\./))
        return 11;

    else
        return 0; //It is not IE
}

$(".extern-cookies-popup").on('click',function(e) {
    e.preventDefault();
    tC.privacyCenter.showPrivacyCenter();
});

/**
 * JS RCU
 */

$(document).on("click",".add_service_form .add-to-cart", function(e) {
    e.preventDefault(); // prevents the form from being submitted
    $.ajax(
        {
            url:"/cart/add/service/ajax",
            data:$(this).closest("form").serialize(),
            async: false
        }).done( function (data) {
        var selectModal = "#ModalMessage";
        if (data.cartError && !data.cartError.msg.length == 0) {
            modalId = "ModalCartError";
            $('body')
                .append(
                    $('<div />')
                        .html(data.cartError.msgModalHtml)
                        .text());
            selectModal = '#' + modalId;
            $(selectModal).on('hidden.bs.modal', function () {
                $(selectModal).remove();
            });
        } else {
            $(selectModal).html(data);
            var isForfaitShippingIncluded = $(data).find("[data-forfaitShippingIncluded]").length > 0;
            if(!isForfaitShippingIncluded) {

                //$(".faq-banner").insertBefore("#nearMeStorefinderForm");
                $observables.storeLocatorObservables.next('skip');
                ACC.addressgeocode.geocodeAddress();
            }
            $(selectModal).addClass('service-popup');
            var closeButton = '<div class="pull-right"> ' +
                '<button type="button" ' +
                'class="close" ' +
                'data-dismiss="modal" ' +
                'aria-hidden="true"> ' +
                '<img src="/_ui/desktop/common/img/close-big.png" ' +
                'alt="alt" ' +
                'data-dismiss="modal"> ' +
                '</button> ' +
                '</div>';
            $("#ModalMessage").find('#relayPointsContainer').prepend(closeButton);
            /*BRA-19430 */
            $("#ModalMessage").find('#repair-store-filter').on('hidden.bs.collapse', function (e) {
                if (!e)
                    e = window.event;
                if (e.stopPropagation) {
                    e.stopPropagation();
                }
                else {
                    e.cancelBubble = true;
                }
            });
            $("#ModalMessage").find('.d-none-md #repair-store-filter').on('hidden.bs.collapse', function (e) {
                if (!e)
                    e = window.event;
                if (e.stopPropagation) {
                    e.stopPropagation();
                }
                else {
                    e.cancelBubble = true;
                }
            });
            $("#ModalMessage").on('hidden.bs.modal', function () {
                $("#ModalMessage .modal-body").html("");
            });

        }
        $(selectModal).show();
        $(selectModal).modal();
    }).fail( function (error) {
        console.error("Error trying to add service product: " + error);
        var modal = $("#ModalMessage");
        var modalBody = modal.find(".modal-body");
        var sb = new StringBuilder();
        sb.append("<p style='margin-bottom: 20px;'>" + GSEB.properties.defaultCartErrorMessage + "</p>");
        sb.append("<button class='btn btn-action' data-dismiss='modal' style='margin:0 auto; display: block; width: auto; text-align: center'>"+ closePopup +"</button>");
        modalBody.html(sb.toString());
        modal.show();
        modal.modal();
    }
);

});
function chooseAspForReparation(currentAsp,aspName){
    $("input[id='accessory-pointOfServiceName']").val(aspName);
    $(".asp-choosed").removeClass("asp-choosed");
    $("#ShopDetail-"+aspName).find(".inner").addClass("asp-choosed");
    $("#add-service-messageError").hide();
}


function closeModalMessage(idModalMessage) {
    $('#' + idModalMessage).modal('hide');
    $(".add-service-popup").remove();
}


//RCU Newsletter
$('#register-rules[type="checkbox"][name="conditionRegister"]').prop("checked", false).trigger('change');
$('#register-rules, .newsletter-label').on('change', function (e) {
    $('#register-rules').toggleClass('checked');
});

$('.infobulle-gauche').on('click', function (e) {
  $('.infobulle-gauche').toggleClass('isOpen');
});

$(document).ready(function(){
    $("body").on('mouseup',function(e)
    {
        var container = $('.infobulle-gauche');
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            container.removeClass('isOpen');
        }
    });
});
$(document).ready(function(){
    window.$observables = window.$observables || {};
    $observables.prcListObservable = $observables.prcListObservable || new Observable();
    if(isMobile) {
        if($observables){
            $observables.mainObservable.subscribe(function(event) {
                if(event.type === 'prc-scroll-to-maps'){

                    $('#relayPointsContainer').animate({
                        scrollTop: $("#map-canvas").offset().top + 100
                    });
                }

            });
            $observables.prcListObservable.subscribe(function (event) {
                if (event.type === 'prc-list-scroll-to-item') {
                    $container = $('#relayPointsContainer');
                    $scrollToElement = $('#pointAcheminementDetail-'+event.identifiant);
                    $container.animate({
                        scrollTop: $scrollToElement.offset().top - $('.relaitList').offset().top + 570
                    });
                }
            });
        }
    }
    $('.claim-container').on("click",".main-claim a",function(e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
    });
    $(document).on("click",".claim-container:not(.main-claim a)",function(e) {
        if(!$(e.target).is('a')){
            document.location.href =$(this).data('product-url');
        }
    });


});

/**
 *  Live-chat
 */

document.addEventListener("DOMContentLoaded", function () {

  if (showChat == "true") {
    if (!GSEB.platform.isMobile()) {
      setTimeout(function () {
        $('.live-chat-block').addClass("live-chat-block-semi-active").removeClass("live-chat-block-inactive");
        setTimeout(function () {
          $('.live-chat-block').addClass("live-chat-block-inactive").removeClass("live-chat-block-semi-active");
        }, liveChatDuration);
      }, liveChatDelay);
    }

    $(".live-chat-block").on("click",".live-chat-picto",function(){
      $('.live-chat-block').addClass("live-chat-block-active").removeClass("live-chat-block-inactive")
        .removeClass("live-chat-block-semi-active");
      $('.live-chat-block').attr("data-analytics-chatClick-chatAction","Open");
      $('.live-chat-block .live-chat-picto').hide(750);
      $('.live-chat-block .live-chat-close').show(750);
    });

    $(".live-chat-block").on("click",".helpButton",function(){
      $('.live-chat-block').attr("data-analytics-chatClick-chatAction", "Ask a question");
    });

    $('.live-chat-block .live-chat-close').click(function (e) {
      $('.live-chat-block').removeClass("live-chat-block-active").addClass("live-chat-block-inactive");
      $('.live-chat-block').attr("data-analytics-chatClick-chatAction","Close");
      $('.live-chat-block .live-chat-picto').show(750);
      $('.live-chat-block .live-chat-close').hide(750);
    });
  }
});

//Scroll to top
var element = document.querySelector('#ModalMessage');
var observer = new MutationObserver(function() {
  document.querySelector("#ModalMessage .modal-body").scrollTo(0,0)
});
observer.observe(element, {
  attributes: true, childList: false
});
